const c = {
  name: "UnitedKingdom",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M39.9,18c0.1,0.7,0.1,1.3,0.1,2c0,0.7,0,1.3-0.1,2h0l-0.2,1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2L39.6,24h0
			c-0.6,3.2-2.1,6.1-4,8.6c-0.9,1.1-1.9,2.1-3,3c-2.4,2-5.4,3.4-8.6,4v0l-0.7,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0l-1,0.2v0
			C21.3,40,20.7,40,20,40s-1.3,0-2-0.1v0l-1-0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0L16,39.6v0c-3.2-0.6-6.1-2.1-8.6-4
			c-1.1-0.9-2.1-1.9-3-3c-2-2.4-3.4-5.4-4-8.6h0l-0.1-0.6c0-0.1,0-0.1,0-0.2l0,0c0-0.1,0-0.1,0-0.2l-0.2-1h0C0,21.3,0,20.7,0,20
			c0-0.7,0-1.3,0.1-2h0l0.2-1c0-0.1,0-0.1,0-0.2l0,0c0-0.1,0-0.1,0-0.2L0.4,16h0c0.6-3.2,2.1-6.1,4-8.6c0.9-1.1,1.9-2.1,3-3
			c2.4-2,5.4-3.4,8.6-4v0l0.6-0.1c0.1,0,0.1,0,0.2,0l0,0c0.1,0,0.1,0,0.2,0l1-0.2v0C18.7,0,19.3,0,20,0s1.3,0,2,0.1v0l1,0.2
			c0.1,0,0.1,0,0.2,0l0,0c0.1,0,0.1,0,0.2,0L24,0.4v0c3.2,0.6,6.1,2.1,8.6,4c1.1,0.9,2.1,1.9,3,3c2,2.4,3.4,5.4,4,8.6h0l0.1,0.7
			c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2L39.9,18L39.9,18z M18,18H2.1C2,18.7,2,19.3,2,20c0,0.7,0,1.3,0.1,2H18v15.9
			c0.7,0.1,1.3,0.1,2,0.1s1.3,0,2-0.1V22h15.9c0.1-0.7,0.1-1.3,0.1-2c0-0.7,0-1.3-0.1-2H22V2.1C21.3,2,20.7,2,20,2s-1.3,0-2,0.1V18z
			 M28.2,16h9.3c-0.5-2.3-1.5-4.5-2.9-6.4L28.2,16z M25.4,16l8-8C33,7.5,32.5,7,32,6.6l-8,8V16H25.4z M24,11.8l6.4-6.4
			C28.5,4,26.3,3,24,2.4V11.8z M28.2,24l6.4,6.4c1.4-1.9,2.3-4.1,2.9-6.4H28.2z M25.4,24H24v1.4l8,8c0.5-0.4,1-0.9,1.4-1.4L25.4,24z
			 M30.4,34.7L24,28.2v9.3C26.3,37,28.5,36,30.4,34.7z M2.4,24C3,26.3,4,28.5,5.3,30.4l6.4-6.4H2.4z M6.6,32C7,32.5,7.5,33,8,33.4
			l8-8V24h-1.4L6.6,32z M16,37.6v-9.3l-6.4,6.4C11.5,36,13.7,37,16,37.6z M16,2.4C13.7,3,11.5,4,9.6,5.3l6.4,6.4V2.4z M16,14.6l-8-8
			C7.5,7,7,7.5,6.6,8l8,8H16V14.6z M11.8,16L5.3,9.6C4,11.5,3,13.7,2.4,16H11.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as UnitedKingdom
};
